import type React from 'react';
import classes from './employees-page.module.scss';
import { useEmployeesPageController } from './useEmployeesPageController';
import { EmployeeDirectory } from './components/EmployeeDirectory';
import { EmployeeDialogs } from './components/EmployeeDialogs';

export const EmployeesPage: React.FC = () => {
  const model = useEmployeesPageController();
  const { isLoading, error, loadEmployees, employees, filteredAndSortedEmployees } = model;
  if (isLoading) {
    return (
      <section className="contentCard" dir="rtl">
        <h1 className="homeTitle">עובדים</h1>
        <p className="homeHint">טוען עובדים...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="contentCard" dir="rtl">
        <h1 className="homeTitle">עובדים</h1>
        <p className="errorText inlineMessage">{error}</p>
        <button
          className="button retryButton"
          type="button"
          onClick={() => {
            void loadEmployees();
          }}
        >
          נסה שוב
        </button>
      </section>
    );
  }

  const hasNoEmployees = employees.length === 0;

  const hasNoResults = employees.length > 0 && filteredAndSortedEmployees.length === 0;
  return (
    <>
      <EmployeeDirectory {...model} hasNoEmployees={hasNoEmployees} hasNoResults={hasNoResults} />
      <EmployeeDialogs {...model} />
    </>
  );
};
